export default __webpack_public_path__ + "locales/tr/CreateEditRoomDialog.json?hash=37168a7f80ceb64002e36f14cd20b535";